import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'

import PropTypes from 'prop-types'
import moment from 'moment'
import classNames from 'classnames'

import Loader from '../UI/Loader'

import _ from 'lodash'
import get from 'lodash/get'

import DatePicker from 'react-datepicker'
import ReactBootstrapSlider from 'react-bootstrap-slider'

import { TextInput, Button, DropZone, TextAreaInput, RadioButton } from '../UI'
import TravelerForm from './TravelerForm'

import { validateRequired } from './../../libs/validation'

import config from './../../config'
import { client } from './../../index'
import { enumerateDaysBetweenDates } from './../../libs/utils'

import queries from './../../graphql/TripForm'
import { NotificationManager } from 'react-notifications'
import queriesTP from './../../graphql/TripPlanner'

import DELETE_FILE from './../../graphql/DeleteFile.graphql'

const DEFAULT_TRAVELER = {
  name: '',
  yearOfBirth: 2016
}

const initOrders = [
  {
    label: 'Please select order...',
    value: ''
  },
  {
    label: 'Template',
    value: 'template'
  }
]

var orders = initOrders.slice()

const initialUtils = {
  startDateMaxDate: null,
  endDateMinDate: moment(),
  endDateDisabled: true,
  coverPhotoURL: null
}

const initialForm = {
  startDate: undefined,
  endDate: undefined,
  numDays: 1,
  requestedBudgetMin: 250,
  requestedBudgetMax: 2000,
  tripBudgetType: 'PerPerson',
  travelers: [DEFAULT_TRAVELER],
  tripDetails: {
    title: '',
    description: '',
    coverPhotoId: null
  }
}

class CreateTripForm extends Component {
  static propTypes = {
    updateItineraryDayIndex: PropTypes.func,
    linkItineraryDayAndTripDetails: PropTypes.func,
    createAllItineraryDays: PropTypes.func,
    createCustomizedPlan: PropTypes.func,
    createTripDetails: PropTypes.func,
    updateCustomizedPlan: PropTypes.func,
    updateContentEventDates: PropTypes.func,
    updateItineraryDayDate: PropTypes.func,
    updateTripDetails: PropTypes.func,
    connectTripDetails: PropTypes.func,
    connectInvitedUser: PropTypes.func,
    getGuruNewOrders: PropTypes.shape({
      loading: PropTypes.bool,
      allCustomizedPlans: PropTypes.array,
      refetch: PropTypes.func
    }),
    deleteFile: PropTypes.func,
    onSave: PropTypes.func,
    isFluid: PropTypes.bool,
    isTrip:PropTypes.bool,
    trip: PropTypes.object,
    t: PropTypes.func,
  }

  static defaultProps = {
    isFluid: false,
    isTrip:false
  }

  constructor(props) {
    super(props)

    this.state = {
      order: '',
      utils: initialUtils,
      form: initialForm,
      waiting: false
    }
  }

  componentDidMount() {
    const { trip } = this.props
    console.log("props",this.props)

    if (trip) {
      this.initTripOrder(trip)
    }

    if (this.props.location && this.props.location.state) {
      this.setState({
        invitedUserId: this.props.location.state.invitedUserId
      })
    }
  }

  initFromOrder(trip, specificStartDate) {
    this.setState(
      {
        form: {
          requestedBudgetMin: trip.requestedBudgetMin || initialForm.requestedBudgetMin,
          requestedBudgetMax: trip.requestedBudgetMax || initialForm.requestedBudgetMax,
          tripBudgetType: trip.tripBudgetType || initialForm.tripBudgetType,
          travelers: trip.travelers || [DEFAULT_TRAVELER],
          tripDetails: {
            title: _.get(trip, 'tripDetails.title') || initialForm.tripDetails.title,
            description: _.get(trip, 'tripDetails.description') || initialForm.tripDetails.description,
            coverPhotoId: _.get(trip, 'tripDetails.coverPhoto.id') || initialForm.tripDetails.coverPhotoId
          }
        },
        utils: {
          ...this.state.utils,
          coverPhotoURL: _.get(trip, 'tripDetails.coverPhoto.url')
        },
        selectedOrder: trip
      },
      () => {
        this.onDateChange('startDate', specificStartDate || moment(trip.startDate) || initialForm.startDate, () => {
          this.onDateChange('endDate', moment(trip.endDate) || initialForm.endDate)
        })
      }
    )
  }

  componentWillReceiveProps(next) {
    
    const { trip } = this.props

    if (!trip) {
      if (!next.getGuruNewOrders.loading) {
        const { allCustomizedPlans } = next.getGuruNewOrders

        if (next.customizedPlan.CustomizedPlan) {
          let theTrip = next.customizedPlan.CustomizedPlan
          this.setState(
            { trip: theTrip
            }); 
          this.initFromOrder(theTrip, moment())
        }


        if (!this.state.invitedUserId) {
          if (!next.getGuruNewOrders.loading) {
            const { allCustomizedPlans } = next.getGuruNewOrders

            if (allCustomizedPlans && allCustomizedPlans.length > 0) {
              if (!this.state.orders) {
                this.setState({
                  orders: allCustomizedPlans
                })
                // Add the orders to the object
                orders = []
                orders = orders.concat(initOrders)
                allCustomizedPlans.map((order, index) => {
                  if (order.orderingUser) {
                    orders.push({
                      label:
                        order.orderingUser.userProfile.firstName +
                        ' ' +
                        order.orderingUser.userProfile.lastName +
                        ' (' +
                        moment(order.createdAt).format('DD MMM YY') +
                        ')',
                      value: order.id
                    })
                  }
                })
              }
              /* If trip received from props it is initialized at compoenentDidMount
              if (trip) {
                this.onOrderChange(trip.id)
              }
              */
            }
          }
        }
      }
    }
  }

  initTripOrder(trip) {
    this.setState({
      order: trip,
      utils: initialUtils,
      form: initialForm
    }, () => {
      this.initFromOrder(trip)
    })
  }
  onOrderChange(order) {
    this.setState({ order }, () => {
      if (this.state.order === '') {
        this.setState({
          utils: initialUtils,
          form: initialForm
        })
      }

      if (order != 'template' && this.state.orders) {
        let selectedOrders = this.state.orders.filter((anOrder, i) => anOrder.id == order)
        if (selectedOrders.length > 0) {
          this.initFromOrder(selectedOrders[0])
        }
      }
    })
  }

  addAnotherTraveler() {
    this.setState({
      form: {
        ...this.state.form,
        travelers: [...this.state.form.travelers, DEFAULT_TRAVELER]
      }
    })
  }

  onSlideStop(min, max) {
    this.onFormFieldChange('form.requestedBudgetMin', min)
    this.onFormFieldChange('form.requestedBudgetMax', max)
  }

  onFormFieldChange(id, value) {
    const newState = _.set(this.state, id, value)

    this.setState(newState)
  }

  onDateChange(id, value, cb) {
    const { form } = this.state
    const newState = {
      form: {
        ...form
      }
    }

    if (form.startDate) {
      if (id === 'numDays') {
        newState.form.endDate = form.startDate.clone().add(value - 1, 'days')
      } else if (id === 'startDate' && form.endDate) {
        newState.form.numDays = moment(form.endDate.diff(value)).days()
      } else if (id === 'endDate') {
        newState.form.numDays = value.diff(form.startDate, 'days') + 1
      }
    }

    newState.form[id] = value

    this.setState(newState, () => {
      this.setState(
        {
          utils: {
            ...this.state.utils,
            endDateDisabled: !this.state.form.startDate,
            endDateMinDate: this.state.form.startDate || moment(),
            startDateMaxDate: this.state.form.endDate || null
          }
        },
        () => {
          if (_.isFunction(cb)) {
            cb()
          }
        }
      )
    })
  }

  renderCoverPhoto() {
    return (
      <div className="cover-photo__container">
        <img className="cover-photo__image" src={this.state.utils.coverPhotoURL} alt="Cover" />
        <button className="cover-photo__remove-button remove-button" onClick={e => this.onCoverDelete(e)}>
          <i className="icon-delete" />
        </button>
      </div>
    )
  }

  onCoverDelete(event) {
    event.stopPropagation()

    const { form } = this.state
    const self = this

    this.props
      .deleteFile({
        variables: {
          id: form.tripDetails.coverPhotoId
        }
      })
      .then(
        () => {
          self.setState({
            utils: {
              ...self.state.utils,
              coverPhotoURL: null
            },
            form: {
              ...self.state.form,
              coverPhotoId: null
            }
          })
        },
        err => {
          console.warn(err)
        }
      )
  }

  onDrop(accepted, rejected) {
    if (Array.isArray(accepted) && accepted.length) {
      const body = new FormData()
      const self = this

      body.append('data', accepted[0])

      fetch(config.fileAPI, {
        method: 'POST',
        body
      })
        .then(response => response.json())
        .then(file => {
          self.onFormFieldChange('form.tripDetails.coverPhotoId', file.id)

          self.setState({
            utils: {
              ...this.state.utils,
              coverPhotoURL: file.url
            }
          })
        })
    } else {
      console.warn('REJECTED', rejected)
    }
  }

  onTravelerDelete(index) {
    this.setState({
      form: {
        ...this.state.form,
        travelers: this.state.form.travelers.filter((traveler, i) => i !== index)
      }
    })
  }

  async adjustTripDates (variables) {
    let { trip } = this.state

    let modifiedTrip = _.cloneDeep(trip)

    let oldStart = moment(trip.startDate).startOf('day')
    let oldEnd = moment(trip.endDate).startOf('day')
    let newStart = moment(variables.startDate).startOf('day')

    let diffDays = newStart.diff(oldStart, 'days')

    // Now start adjusting the trip 
    modifiedTrip.startDate = oldStart.add(diffDays, 'days').toISOString()
    modifiedTrip.endDate = oldEnd.add(diffDays, 'days').toISOString()

    variables.endDate = modifiedTrip.endDate

    let events =  []
    if (modifiedTrip.tripDetails.itineraryDays) {
      modifiedTrip.tripDetails.itineraryDays.map(day => {
        day.dayOfTrip = moment(day.dayOfTrip).add(diffDays, 'days').toISOString()
        if (day.contentEvents) {
          day.contentEvents.map(event => {
            event.startDate = moment(event.startDate).add(diffDays, 'days').toISOString()
            event.endDate = moment(event.endDate).add(diffDays, 'days').toISOString()
            events.push(event)
          })
        }
      })
    }

    try {
      // Update al date changes
      await Promise.all(events.map(event => {
        return this.props.updateContentEventDates({
          variables: event
        })
      }))
      await Promise.all(modifiedTrip.tripDetails.itineraryDays.map(day => {
        return this.props.updateItineraryDayDate({
          variables: day
        })
      }))
    }
    catch(err) {
      console.warn(err)
    }
  }

  matchExistingDay(day, itineraryDays) {
    var result = -1
    itineraryDays.some(function(el, i) {
      return day.dayOfTrip === el.dayOfTrip ? ((result = i), true) : false
    })
    return result
  }

  async onNextClick() {
    const { t } = this.props

    const variables = { ...this.state.form }

    const { trip } = this.state

    this.setState({waiting: true})

    variables.tripGuruId = this.props.user.id

    if (variables.startDate) {
      variables.startDate = variables.startDate.startOf('day').toISOString()
    }

    if (variables.endDate) {
      variables.endDate = variables.endDate.startOf('day').toISOString()
    }

    let selectedTrip = this.state.selectedOrder ? this.state.selectedOrder : trip

    if (selectedTrip) {
      // If this is a prepaid order adjust dates
      if (trip && variables.startDate) {
        await this.adjustTripDates(variables)
      }

      variables.id = selectedTrip.id

      if (variables.travelers.length) {
        const ids = variables.travelers.filter(t => t.id).map(t => t.id)

        if (ids.length) {
          const reduceFunction = (p, c, i) => {
            return `${p}\nid${i}: deleteTraveler(id: "${c}") { id }`
          }

          client
            .mutate({
              mutation: gql`
                mutation DeleteTravelers {
                  ${ids.reduce(reduceFunction, '')}
                }
              `
            })
            .catch(err => {
              console.warn(err)
              NotificationManager.error(err.message, 'Error', 5000)
            })
        }

        /*variables.travelers.map(t => {
          delete t.id
          delete t.__typename
        })*/
      }

      const tripDetails = {...variables.tripDetails}
      const oldItineraryDays = selectedTrip.tripDetails.itineraryDays
      let itineraryDays

      // Check if there is a date change - this requires update of the itinerary days

      if (!trip) {
        if (variables.startDate != selectedTrip.startDate || variables.endDate != selectedTrip.endDate) {
          let days = enumerateDaysBetweenDates(variables.startDate, variables.endDate)
          itineraryDays = days.map((day, i) => {
            const dayTitle = t('day_prefix') + (i + 1)
            const newDate = {
              index: i,
              title: dayTitle
            }

            if (day) {
              newDate.dayOfTrip = day.startOf('day').toISOString()
            }

            return newDate
          })

          tripDetails.itineraryDays = itineraryDays
        }
      }

      if (selectedTrip.tripDetails) {
        tripDetails.id = selectedTrip.tripDetails.id
      }

      if (tripDetails.id) {
        delete tripDetails.itineraryDays;

        try {
          await Promise.all([
            this.props.updateCustomizedPlan({ variables }),
            this.props.updateTripDetails({
              variables: tripDetails
            })
          ])
          if (itineraryDays) {
            // Get all new itinerary days - they will be created
            // the ones that are kept from the old....need to change their details to match
            //
            let reusedItineraryDays = []
            itineraryDays = itineraryDays.filter(oneDay => {
              // Check if this day is on the original
              let i = this.matchExistingDay(oneDay, oldItineraryDays)
              if (i >= 0) {
                let matchingItem = _.cloneDeep(oldItineraryDays[i])
                const defaultTitle = t('day_prefix') + (matchingItem.index + 1)
                matchingItem.index = oneDay.index
                if (matchingItem.title == defaultTitle) {
                  matchingItem.title = oneDay.title
                }
                reusedItineraryDays.push(matchingItem)
                return false
              } else {
                return true
              }
            })
            await Promise.all([
              this.props.createAllItineraryDays({
                variables: { id: tripDetails.id, itineraryDays: itineraryDays }
              })
            ])
            if (reusedItineraryDays.length > 0) {
              await Promise.all(
                reusedItineraryDays.map(item => {
                  return this.props.linkItineraryDayAndTripDetails({
                    variables: { itineraryDayId: item.id, tripDetailsId: tripDetails.id }
                  })
                })
              )
              await Promise.all(
                reusedItineraryDays.map(item => {
                  return this.props.updateItineraryDayIndex({
                    variables: { id: item.id, index: item.index, title: item.title }
                  })
                })
              )
            }
          }
          if (this.props.history) {
            this.props.history.push(`/trip-planner/${variables.id}`)
          }
        } catch (err) {
          console.warn(err)
        }
      } else {
        this.props
          .createTripDetails({
            variables: tripDetails
          })
          .then(async ({ data }) => {
            try {
              await Promise.all([
                this.props.updateCustomizedPlan({ variables }),
                this.props.connectTripDetails({
                  variables: {
                    customizedPlanId: variables.id,
                    tripDetailsId: data.createTripDetails.id
                  }
                })
              ])
              if (this.props.history) {
                this.props.history.push(`/trip-planner/${variables.id}`)
              }
            } catch (err) {
              NotificationManager.error(err.message, 'Error', 5000)
            }
          })
          .catch(err => {
            NotificationManager.error(err.message, 'Error', 5000)
          })
      }

      if (_.isFunction(this.props.onSave)) {
        this.props.onSave()
      }
    }
    else {
      //
        if (this.state.invitedUserId) {
          variables.orderingUserId = this.state.invitedUserId
        }
        this.props
          .createCustomizedPlan({ variables: { ...variables, orderStatus: 'NewOrder' } })
          .then(({ data }) => {
            this.props.history.push(`/trip-planner/${data.createCustomizedPlan.id}`)
          })
          .catch(err => {
            NotificationManager.error(err.message, 'Error', 5000)
          })
    }
    this.setState({waiting: false})

  }

  render() {

    console.log(this.props.isTrip)
    
    if(this.props.isTrip){
      if (this.props.trip.loading || this.props.loading) {
        return <Loader showLoader={true} />
      }
    } else{
      if (this.props.getGuruNewOrders.loading || this.props.loading) {
        return <Loader showLoader={true} />
      }
    }
    

    if (!this.props.user) {
      this.props.history.push('/')
    }

    const { t, isFluid } = this.props
    const { form, utils, order, trip } = this.state

    const isPrepaid = trip || this.state.invitedUserId

    return (
      <div
        className={classNames({
          container: !isFluid,
          'container-fluid': isFluid,
          'create-trip': true
        })}
      >
        <Loader showLoader={this.state.waiting} />
        <div className="row">
          <div
            className={classNames({
              'col-md-6 col-md-offset-3': !isFluid,
              'col-md-12': isFluid
            })}
          >
            <h1>{t('page_title')}</h1>
            
            {!isPrepaid && <hr />}

            {!isPrepaid &&
              <div className="form-horizontal create-trip__form-container">
                <h2 className="create-trip__form-group-label">{t('order')}</h2>

                <div className="form-group">
                  <div className="col-md-12">
                    <select id="order"
                            className="form-control create-trip__form-input"
                            value={order}
                            onChange={e => this.onOrderChange(e.target.value)}>
                      {orders.map((order, index) => (<option key={index} value={order.value}>{order.label}</option>))}
                    </select>
                  </div>
                </div>
              </div>
            }
            {(order !== '' || isPrepaid) && <hr />}

            {(order !== '' || isPrepaid) &&
              <div>
                <div className="form-horizontal create-trip__form-container">
                  <h2 className="create-trip__form-group-label">{t('name_and_date')}</h2>

                  <TextInput
                    isGroup={true}
                    label={t('name_label')}
                    labelClass="create-trip__form-label col-md-3 control-label"
                    inputWrapperClass="col-md-9"
                    id="form.tripDetails.title"
                    extraClass="form-control create-trip__form-input"
                    placeholder={t('name_placeholder')}
                    validationFuncs={[validateRequired]}
                    initialValue={trip ? trip.tripDetails.title : form.tripDetails.title}
                    onChangeExternal={(id, value) => this.onFormFieldChange(id, value)}
                  />

                  <fieldset className="form-group">
                    <label htmlFor="startDate" className="create-trip__form-label col-md-3 control-label">
                      {t('start_date')}
                    </label>
                    <div className="col-md-9">
                      <DatePicker id="startDate"
                                  selected={form.startDate}
                                  minDate={moment()}
                                  maxDate={!trip ? utils.startDateMaxDate : null}
                                  onChange={value => this.onDateChange('startDate', value)}
                                  dateFormat="DD/MM/YYYY"
                                  className="form-control create-trip__form-input"
                                  placeholderText="--/--/----" />
                    </div>
                  </fieldset>

                  {!trip && 
                    <div className="form-group">
                      <label htmlFor="endDate"
                            className="create-trip__form-label col-md-3 control-label">{t('end_date')}</label>
                      <div className="col-md-9">
                        <DatePicker id="endDate"
                                    selected={form.endDate}
                                    minDate={utils.endDateMinDate}
                                    disabled={utils.endDateDisabled}
                                    onChange={value => this.onDateChange('endDate', value)}
                                    dateFormat="DD/MM/YYYY"
                                    className="form-control create-trip__form-input"
                                    placeholderText="--/--/----">
                        </DatePicker>
                      </div>
                    </div>
                  }

                  {!trip && 
                    <TextInput label={t('total_days')}
                              labelClass="create-trip__form-label col-md-3 control-label"
                              inputWrapperClass="col-md-3"
                              type="number"
                              id="numDays"
                              extraClass="form-control create-trip__form-input"
                              initialValue={form.numDays}
                              min={1}
                              onChangeExternal={(id, value) => this.onDateChange(id, +value)} />
                            }
                </div>
                <hr />

                <div className="form-horizontal create-trip__form-container">
                  <h2 className="create-trip__form-group-label">{t('description_label')}</h2>
                  <div className="create-trip__example-container">
                    <i className="icon-flag create-trip__example-icon" />
                    <span className="create-trip__example-text">{t('description_example')}</span>
                  </div>

                  <TextAreaInput
                    id="form.tripDetails.description"
                    maxChars={100} 
                    initialValue={_.get(form, 'tripDetails.description', '')}
                    onChangeExternal={(id, props) => this.onFormFieldChange(id, props)}
                    placeholder={t('description_placeholder')}
                  />
                </div>
                <hr />

                <div className="form-horizontal create-trip__form-container clearfix">
                  <h2 className="create-trip__form-group-label">{t('budget')}</h2>

                  <div className="row">
                    <div className="budget-slider col-md-12">
                      <ReactBootstrapSlider
                        min={250}
                        max={20000}
                        step={50}
                        value={[form.requestedBudgetMin, form.requestedBudgetMax]}
                        orientation="horizontal"
                        slideStop={e => this.onSlideStop(e.target.value[0], e.target.value[1])}
                      />

                      <div className="range">
                        <span className="range-value">$250</span>
                        <span className="range-value right-value">$20,000</span>
                      </div>
                    </div>

                    <div className="col-md-3 create-trip__radio-btn">
                      <RadioButton
                        value="PerPerson"
                        id="perPerson"
                        onChange={event => this.onFormFieldChange('form.tripBudgetType', event.target.value)}
                        checked={this.state.form.tripBudgetType === 'PerPerson'}
                      >
                        {t('for_person')}
                      </RadioButton>
                    </div>
                    <div className="col-md-3 create-trip__radio-btn">
                      <RadioButton
                        value="TotalTrip"
                        id="totalTrip"
                        onChange={event => this.onFormFieldChange('form.tripBudgetType', event.target.value)}
                        checked={this.state.form.tripBudgetType === 'TotalTrip'}
                      >
                        {t('total')}
                      </RadioButton>
                    </div>
                  </div>
                </div>
                <hr />

                <div className="create-trip__form-container">
                  <h2 className="create-trip__form-group-label">Travelers</h2>

                  {form.travelers.map((traveler, index) => (
                    <div key={index}>
                      <TravelerForm
                        index={index}
                        traveler={traveler}
                        onDelete={index => this.onTravelerDelete(index)}
                        onFormFieldChange={(id, value) => this.onFormFieldChange(`form.travelers[${index}].${id}`, value)}
                      />
                      {index !== form.travelers.length - 1 && <hr />}
                    </div>
                  ))}

                  <div className="create-trip__add-another-traveler" onClick={() => this.addAnotherTraveler()}>
                    <i className="icon-plus" />
                    <span>{t('add_another_traveler')}</span>
                  </div>
                </div>
                <hr />

                <div className="create-trip__add-cover-photo create-trip__form-container">
                  <h2 className="create-trip__form-group-label">{t('add_cover_photo')}</h2>

                  <DropZone
                    onDrop={(accepted, rejected) => this.onDrop(accepted, rejected)}
                    maxSize={2000000}
                    className="create-trip__cover-photo-dropzone"
                    accept="image/*"
                  >
                    {utils.coverPhotoURL ? this.renderCoverPhoto() : <i className="icon-plus" />}
                  </DropZone>
                </div>

                <Button name={t('next')} onSubmit={() => this.onNextClick()} className="btn create-trip__submit-btn" />
              </div>
              }
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  translate('create_trip'),
  graphql(queriesTP.CREATE_ALL_ITINERARY_DAYS, {
    name: 'createAllItineraryDays'
  }),
  graphql(queriesTP.GET_CUSTOMIZED_PLAN, {
    name: 'customizedPlan',
    options: props => ({
      variables: {
        id: (props.match && props.match.params.tripId) ? props.match.params.tripId : ''
      },
      fetchPolicy: 'network-only'
    })
  }),
  graphql(queriesTP.LINK_ITINERARY_DAY_AND_TRIP_DETAILS, {
    name: 'linkItineraryDayAndTripDetails'
  }),
  graphql(queriesTP.UPDATE_CONTENT_EVENT_DATES, {
    name: 'updateContentEventDates'
  }),
  graphql(queriesTP.UPDATE_ITINERARY_DAY_DATE, {
    name: 'updateItineraryDayDate'
  }),
  graphql(queriesTP.UPDATE_ITINERARY_DAY_INDEX, {
    name: 'updateItineraryDayIndex'
  }),
  graphql(queries.CREATE_CUSTOMIZED_PLAN, {
    name: 'createCustomizedPlan'
  }),
  graphql(queries.CREATE_TRIP_DETAILS, {
    name: 'createTripDetails'
  }),
  graphql(queries.CONNECT_TRIP_DETAILS, {
    name: 'connectTripDetails'
  }),
  graphql(queries.CONNECT_INVITED_USER, {
    name: 'connectInvitedUser'
  }),
  graphql(queries.UPDATE_CUSTOMIZED_PLAN, {
    name: 'updateCustomizedPlan'
  }),
  graphql(queries.UPDATE_TRIP_DETAILS, {
    name: 'updateTripDetails'
  }),
  graphql(queries.GET_GURU_NEW_ORDERS, {
    name: 'getGuruNewOrders',
    options: props => ({
      variables: {
        tripGuruId: _.get(props, 'user.id', '')
      }
    })
  }),
  graphql(DELETE_FILE, {
    name: 'deleteFile'
  })
)(CreateTripForm)



// WEBPACK FOOTER //
// src/components/CreateTripForm/index.js